export const GoogleStoreLink = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <a
      href={`https://chrome.google.com/webstore/detail/${process.env.NEXT_PUBLIC_GOOGLE_STORE_ID}?utm_source=snaptheprice`}
      className="block"
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  )
}
